import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default function buildRouter (routes, store) {
  const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
      return { x: 0, y: 0 }
    }
  })

  router.beforeEach((to, from, next) => {
    if (!store.state.user.token && to.name !== 'login' && to.name !== 'forgot-password' && to.name !== 'reset-password') {
      next({name: 'login'})
    } else if (store.state.user.token && to.name === 'home') {
      next({name: 'welcome'})
    }
    next()
  })

  return router
}



// WEBPACK FOOTER //
// ./src/plugins/vue-router.js